var SlideTab = {

  $slidesContainer : null,
  $tabsContainer   : null,
  $slides          : null,
  $tabs            : null,
  currentIndex     : 0,
  tabWidth         : null,
  intervalId       : null,
  progressStep     : null,
  $progressHolder  : null,
  $progressBar     : null,
  progressBarWidth : 0,

  options : {
    smooth              : false,
    smoothSpeed         : 500,
    slideDelay          : 10000,
    stepInterval        : 50,
    showEffect          : "fadeIn",
    hideEffect          : "fadeOut",
    showSpeed           : 1000,
    hideSpeed           : 500,
    closedHeight        : 49,
    openedHeight        : 49,
    resetOnResize       : false,
    progressBarClass    : "progress-bar",
    progressHolderClass : "progress-holder",
    dataAttribute       : "image"
  },


  /**
     * Initializes and runs SlideTab.
     * @param $slidesContainer {jQuery.Object} Element that contains slides
     * @param $tabsContainer {jQuery.Object} Element that contains tabs
     * @param options {Object} Additional configuration
     */
  initialize : function($slidesContainer, $tabsContainer, options) {
    if (!$slidesContainer || !$tabsContainer) {
      window.alert("SlideTab: Containers aren't defined!");
      return;
    }

    $.extend(this.options, options);

    this.$slidesContainer = $slidesContainer;
    this.$tabsContainer = $tabsContainer;

    //  Computed values
    this.$slides = this.$slidesContainer.children('div');
    this.$tabs = this.$tabsContainer.children('div');
    this.tabWidth = this.$tabsContainer.outerWidth() / this.$tabs.length;
    this.progressStep = (this.options.stepInterval / this.options.slideDelay) * this.tabWidth;

    this.createProgressBar();
    this.prepareTabsAndSlides();
    this.addListeners();
    this.activateTab($(this.$tabs[this.currentIndex]));
  },


  /**
     * Creates progress bar.
     */
  createProgressBar : function() {
    this.$progressHolder = $('<div></div>', {
      'class' : this.options.progressHolderClass
    }).prependTo(this.$tabsContainer);

    this.$progressBar = $('<div></div>', {
      'class' : this.options.progressBarClass
    }).prependTo(this.$progressHolder);
  },


  /**
     * Adds background to tabs and slides and sets width to tabs.
     */
  prepareTabsAndSlides : function() {
    var self = this;

    this.$slides.each(function(index, item) {
      var $slide = $(item),
          imgUrl = $slide.data(self.options.dataAttribute);

      $slide.css({ 'background-image' : 'url(' + imgUrl + ')' , 'background-size' : 'cover'});

      $(self.$tabs[index]).css({
        'width'            : self.tabWidth,
        //'background-image' : 'url(' + imgUrl + ')'
      });
    });
  },


  /**
     * Adds event listeners.
     */
  addListeners : function() {
    var self = this;

    //  WINDOW RESIZE
    if (this.options.resetOnResize) {
      window.onresize = function() {
        self.tabWidth = self.$tabsContainer.outerWidth() / self.$tabs.length;
        self.$tabs.css({'width': self.tabWidth});
        self.progressStep = (self.options.stepInterval / self.options.slideDelay) * self.tabWidth;
        //self.$tabs.width(self.tabWidth);
        self.activateTab($(self.$tabs[self.currentIndex]));
      };
    }

    //  CLICK
    this.$tabs.on('click', this.$tabs, function() {
      if (this !== self.$tabs[self.currentIndex]) {
        var $tab = $(this);

        window.clearInterval(self.intervalId);
        self.currentIndex = $tab.index() - 1;
        self.activateTab($tab);
      }
    });

    //  MOUSE OVER
    this.$tabs.on('mouseenter', this.$tabs, function() {
      self.setTabHeight($(this), self.options.openedHeight);
    });

    //  MOUSE OUT
    this.$tabs.on('mouseleave', this.$tabs, function() {
      if (this !== self.$tabs[self.currentIndex]) {
        self.setTabHeight($(this), self.options.closedHeight);
      }
    });
  },


  /**
     * Activates next tab.
     * @param $target {jQuery.Object} Target tab
     */
  activateTab : function($target) {
    var self = this;
    this.resetTabs();

    $(this.$slides[this.currentIndex]).stop()[this.options.showEffect](this.options.showSpeed);
    this.setTabHeight($target, this.options.openedHeight);

    //  SMOOTH OPTION
    /* if (this.options.smooth) {
      this.$progressHolder.animate({
        'width' : (1 + self.currentIndex) * self.tabWidth
      }, this.options.smoothSpeed);
    } else {
      //  default
      this.$progressHolder.width((1 + this.currentIndex) * this.tabWidth);
    } */

    this.progressBarWidth = this.currentIndex * this.tabWidth;
    //this.$progressBar.width(this.progressBarWidth);
    
    this.$progressBar.width(this.tabWidth);
	this.$progressBar.css('transform', 'translate3d(' + this.progressBarWidth + 'px' + ', 0px, 0px)');
    
    this.intervalId = window.setInterval(function() {
      self.fillProgressBar(self);
    }, this.options.stepInterval);
  },


  /**
     * Clears interval and resets tabs.
     */
  resetTabs : function() {
    window.clearInterval(this.intervalId);

    this.setTabHeight(this.$tabs, this.options.closedHeight);
    this.$slides.stop()[this.options.hideEffect](this.options.hideSpeed);
    
    this.$slidesContainer.css('height', Math.round($('.slidetab-slide-container').width() / this.options.slideRatio) + 'px');
  	$('.slidetabs-wrapper').css('height', (this.$slidesContainer.height() + 10 + this.options.openedHeight) + 'px');
  },


  /**
     * Calculates next index in order.
     */
  setCurrentIndex : function() {
    this.currentIndex + 1 < this.$tabs.length ? this.currentIndex++ : this.currentIndex = 0;
  },


  /**
     * Sets tab height.
     * @param $target {jQuery.Object} Target tab.
     * @param height {int} Height in px
     */
  setTabHeight : function($target, height) {
    $target.css('height', height + 'px');
  },


  /**
     * Draws progress bar.
     * @param obj {Object} SlideTab object
     */
  fillProgressBar : function(obj) {
    obj.progressBarWidth += obj.progressStep;
    //obj.$progressBar.width(Math.round(obj.progressBarWidth));
    obj.$progressBar.width(Math.round(obj.tabWidth));

    if (obj.progressBarWidth >= obj.tabWidth * (1 + obj.currentIndex)) {
      obj.setCurrentIndex();
      obj.activateTab($(obj.$tabs[obj.currentIndex]));
    }
  }
};

